import esIntegrations from './esIntegrations';
import esLogin from './esLogin';
import esTopbar from './esTopbar';
import esDrawer from './esDrawer';
import esAccount from './esAccount';
import esEllipsisPopover from './esEllipsisPopover';
import esTemplates from './esTemplates';
import esRules from './esRules';
import esChat from './esChat';
import esSequences from './esSequences';
import esFilter from './esFilter';
import esDashboard from './esDashboard';
import esNotifications from './esNotifications';
import esAutomation from './esAutomation';
import esReports from './esReports';
import esTimezones from './esTimezones';
import esTools from './esTools';
import esSales from './esSales';

export default {
  es: {
    translation: {
      Close: 'Cerrar',
      hello: 'hello',
      Integrations: 'Integraciones',
      Link: 'Vincular',
      Unlink: 'Desvincular',
      'Use Chrome': 'Utiliza Chrome',
      DownloadChrome_Text:
        'Hemos detectado que no estás usando el navegador de Chrome. Para asegurar la mejor experiencia en Uniboxi, te recomendamos cambiarte de navegador a Chrome o descargarlo en caso que no lo tengas.',
      'Download Chrome': 'Descargar Chrome',
      'Add tag': 'Agregar etiqueta',
      'Empty name error': 'El nombre no puede estar vacío',
      'New tag name': 'Nombre de la nueva etiqueta',
      'Add new conversation': 'Agregar nueva conversación',
      'Add contact': 'Añadir contacto',
      'Send Whatsapp': 'Enviar Whatsapp',
      'Whatsapp number': 'Número de WhatsApp',
      'New whatsapp message': 'Nuevo mensaje de Whatsapp',
      'New whatsapp message help':
        'Escriba el número de WhatsApp con el código de país. No es necesario agregar "+" al número.',
      'Edit category': 'Editar nombre de categoría',
      New: 'Nuevo',
      Board: 'Tablero',
      List: 'Lista',
      Filter: 'Filtrar',
      Edit: 'Editar',
      Notes: 'Notas',
      'Add Note': 'Agregar nota',
      Send: 'Enviar',
      send: 'envío',
      sends: 'envíos',
      'Type a message...': 'Escriba su mensaje...',
      'Active sequence...': 'Secuencia activa...',
      Inbox: 'Inbox',
      Inbox_help: 'Arrastre las conversaciones a la categoría que desee',
      'No conversations': 'Arrastre conversaciones a esta categoría',
      'No conversations inbox': 'No tienes nuevas conversaciones',
      'Add Category': 'Agregar categoría',
      'Assign category': 'Asignar categoría',
      'Category Name': 'Nombre de la categoría',
      'Delete category': 'Eliminar categoría',
      'Edit tag': 'Editar etiqueta',
      'Choose a color': 'Elige un color',
      'Deleted conversations': 'Conversaciones eliminadas',
      'New name': 'Nombre nuevo',
      Confirm: 'Confirmar',
      Accept: 'Aceptar',
      Cancel: 'Cancelar',
      'Delete conversation': 'Eliminar conversacion',
      'Delete tag': 'Eliminar etiqueta',
      Delete_tag_help1: '¿Está seguro que desea eliminar esta etiqueta?',
      Delete_help1: '¿Está seguro que desea eliminar esta conversación?',
      Delete_category_help1: '¿Está seguro que desea eliminar esta categoría?',
      Delete_category_help2:
        'No es posible eliminar categorías con clientes. Por favor elimina o mueve todas las conversaciones de la categoría antes de borrarla.',
      Delete_help2:
        'Podrá encontrarla en la sección de conversaciones eliminadas.',
      Restore_help1: '¿Desea restaurar esta conversacion?',
      Restore_help2: 'Podrá encontrarla nuevamente en su inbox.',
      Remove_help1:
        '¿Está seguro que desea eliminar esta conversación definitivamente?',
      Remove_help2: 'No podrá recuperarla nuevamente.',
      'Assign users': 'Asignar usuarios',
      'Assign rules': 'Reglas de asignar mensajes',
      'Write your note': 'Escriba su nota.',
      Delete: 'Eliminar',
      'Add field': 'Agregar campo',
      'Insert file': 'Adjuntar archivo',
      'Insert variable': 'Insertar variable',
      'Go to templates': 'Ir a plantillas',
      Actives: 'Activos',
      Inactives: 'Inactivos',
      'Activate user': 'Activar usuario',
      'Activate user help': '¿Está seguro que desea activar este usuario?',
      'Deactivate user': 'Desactivar usuario',
      'Cancel invitation': 'Cancelar invitación',
      'Deactivate user help': '¿Está seguro que desea desactivar este usuario?',
      'Cancel invitation help':
        '¿Está seguro que desea cancelar esta invitación?',
      'Edit user': 'Editar usuario',
      'Edit users': 'Editar usuario',
      'Delete user': 'Eliminar usuario',
      'Delete user help': '¿Está seguro que desea eliminar este usuario?',
      'Invitation pending': 'Invitación pendiente',
      After: 'Despues',
      'without answer': 'sin respuesta',
      'We are sorry': '¡Lo sentimos!',
      'No available chat':
        'Pronto podrás comunicarte por correo desde Uniboxi.',
      Oops: 'Oops!',
      'We cant find the page you were looking for':
        'No pudimos encontrar la pagina que estás buscando.',
      'You can go to the': 'Puedes volver a la ',
      'last page': 'página anterior',
      'or direct to': 'o dirigirte al ',
      'main dashboard': 'dashboard principal.',
      'home screen': 'pantalla de inicio ',
      'or contact our': 'o contactarte con nuestro ',
      'help center': 'centro de ayuda ',
      'so we can solve your problem': 'para que pueda solucionar tu problema.',
      Hours: 'Hora(s)',
      Days: 'Día(s)',
      Weeks: 'Semana(s)',
      'Restarts in': 'Reinicia en',
      days: 'días',
      Language: 'Lenguaje',
      'Change language': 'Cambiar idioma',
      unknown_first_contact: 'Desconocido',
      'Unknown name': 'Nombre desconocido',
      you: 'Tú',
      'Mark as read': 'Marcar como leído',
      Favourite: 'Favorito',
      'Mark as favourite': 'Marcar como favorito',
      'Unmark as favourite': 'Desmarcar como favorito',
      'Mark as unread': 'Marcar como no leído',
      rate_limit_exceded:
        'Tasa de mensajes excedida para este canal, intente enviar de nuevo mas tarde.',
      timeout_sending:
        'Se ha tardado demasiado tiempo en recibir el mensaje, por favor revisa si el número está correcto.',
      invalid_number: 'Mensaje no enviado. Número de WhatsApp no existe.',
      invalid_number_help:
        'Por favor revisa si el número está correcto. En caso que esté incorrecto, por favor eliminar la tarjeta y crear una nueva para este contacto.',
      'Know more': 'Conocer más.',
      'More information': 'Más información',
      'Send invitation': 'Enviar invitación',
      'No users help': 'Agrega o elimina usuarios de Uniboxi.',
      'Search templates': 'Buscar plantillas',
      'Search sequences': 'Buscar secuencias',
      See: 'Ver',
      All: 'Todos',
      Everybody: 'Todos',
      item: 'Item(s)',
      'Created by me': 'Creados por mi',
      Delete_sequence_help: '¿Está seguro que desea eliminar esta secuencia?',
      Delete_template_help: '¿Está seguro que desea eliminar esta plantilla?',
      Delete_automation_help: '¿Está seguro que desea eliminar este mensaje?',
      Contact_row_moved: 'Se reubicará en orden cronológico.',
      Conversations: 'Conversaciones',
      Active: 'Activo',
      Inactive: 'Inactivo',
      'Drag the categories to the position you want':
        'Arrastre las categorías a la posición que desee.',
      'Change order of categories': 'Cambiar orden de categorías',
      Information24h:
        'Al crear una secuencia, tienes una ventana de 24 horas para enviar mensajes automatizados. Después de 24 horas del último mensaje del cliente, no te puedes comunicar con esta persona hasta que te escriba de nuevo (De acuerdo con las políticas de Facebook Messenger y Whatsapp).',
      'Unlink channel': 'Cuenta desvinculada',
      'Your channel': 'Su cuenta',
      'has disengaged. Click on the': 'se ha desvinculado. Haga click en el',
      'next link': 'siguiente enlace',
      'to re-link': 'para volver a vincular.',
      'Authentication failed. User not found.':
        'Falló la autenticación. Usuario no encontrado.',
      'Authentication failed. Wrong password.':
        'Falló la autenticación. Contraseña incorrecta.',
      'The company isnt confirmed yet.': 'La empresa aún no está confirmada.',
      Search: 'Buscar',
      'Export in .csv format': 'Exportar en formato .csv',
      'Export in .xlsx format': 'Exportar en formato .xlsx',
      'Save contact': 'Guardar contacto',
      'Export dashboard': 'Exportar tablero',
      'Select one of the following options to download your dashboard':
        'Seleccione una de las siguientes opciones para descargar su tablero.',
      'Whole board': 'Todo el tablero',
      'Time frame': 'Período',
      export_help:
        'Le enviaremos un correo electrónico a {{email}} con el link para descargar el archivo en formato {{type}}',
      'Export board': 'Exportar tablero',
      Start: 'Comienzo',
      End: 'Finalización',
      Previous: 'Anterior',
      Next: 'Siguiente',
      'Send to': 'Para',
      'Message for': 'Mensaje para:',
      'Select the paid template you want to send':
        'Seleccione la plantilla paga que desea enviar',
      'Sending from': 'Desde',
      'Add Information (Optional)': 'Agregar Información (Opcional)',
      NewWhatsappMessageHelp:
        'WhatsApp sólo permite usar plantillas preaprobadas para contactar a una persona por primera vez.',
      NewWhatsappNoTemplates:
        'WhatsApp sólo permite usar plantillas pre-aprobadas para contactar a una persona por primera vez. Para agregar su primer plantilla de pago, haga click a continuación.',
      NewWhatsappPlanUpgrade:
        'Funcionalidad exclusiva Plan Pro. Haga click a continuación para mejorar su cuenta.',
      'Go to plans': 'Ir a planes',
      'Complete the following fields with the information you want':
        'Complete los siguientes campos con la información que desee.',
      'View inactive': 'Ver inactivos',
      NoIntegratedChannelsTitle:
        'Ten mejores conversaciones con tus clientes usando mensajería.',
      NoIntegratedChannelsList1:
        'Un tablero simple para ver en un solo lugar todos los mensajes de WhatsApp, Instagram y Facebook Messenger.',
      NoIntegratedChannelsList2:
        'Agrega todo tu equipo de ventas o soporte y divide los mensajes entrantes entre ellos. Luego monitorea fácilmente las conversaciones de tu equipo.',
      NoIntegratedChannelsList3:
        'Comienza integrando un número de WhatsApp, cuenta de Instagram o Messenger.',
      'Start by integrating a WhatsApp number, Instagram or Messenger account.':
        'Comienza integrando un número de WhatsApp, cuenta de Instagram o Messenger.',
      'Integrate a channel': 'Vincular un canal',
      'Transfer conversations in bulk': 'Transferir conversaciones masivamente',
      'Are you sure you want to transfer all':
        '¿Seguro que desea transferir las',
      conversations: 'conversaciones',
      from: 'de',
      to: 'a',
      'Go back': 'Volver',
      'Choose the user who currently owns the conversations.':
        'Elija al usuario propietario de las conversaciones actualmente.',
      'What categories of conversations do you want to transfer?':
        '¿Qué categorías de conversaciones desea transferir?',
      "Choose the user you'll transfer the conversations to.":
        'Elija al usuario a quien transferir las conversaciones.',
      Continue: 'Continuar',
      'Transfer completed': 'Transferencia completada',
      'The transfer was completed successfully.':
        'La transferencia fue completada con éxito.',
      'Active users': 'Usuarios activos',
      'Inactive users': 'Usuarios inactivos',
      'Select a user': 'Selecciona un usuario',
      'Search in': 'Buscar en',
      'Drop your files here': 'Suelta tus archivos aquí',
      'Copy image': 'Copiar imagen',
      'Download image': 'Descargar imagen',
      Status: 'Estado',
      Categories: 'Categorías',
      'Delete batch_send': 'Eliminar envío masivo',
      Delete_batch_send_help1:
        '¿Estás seguro que deseas eliminar este envío masivo?',
      'Stop batch send': 'Detener envío masivo',
      'Are you sure you want to stop this batch send?':
        '¿Estás seguro que deseas detener este envío masivo?',
      Stop: 'Detener',
      'Batch Sends': 'Envíos Masivos',
      'Manage your batch message campaigns':
        'Gestionar envío de mensajes masivos',
      Segment: 'Segmento',
      'No batch sends yet': 'Aún no hay envíos masivos',
      Important: 'Importante',
      'Message will only be viewed by recent contacts':
        'Este mensaje solo lo recibirán las personas que les escribieron durante los últimos 7 días.',
      'Start sending batch messages to your customers. Create your first campaign and reach multiple contacts at once.':
        'Comienza a enviar mensajes masivos a tus clientes. Crea tu primera campaña y llega a múltiples contactos a la vez.',
      Created: 'Creado',
      Company: 'Empresa',
      'Spreadsheet Name': 'Nombre de la Hoja de Cálculo',
      'Messages Sent': 'Mensajes Enviados',
      Spreadsheet: 'Hoja de Cálculo',
      Actions: 'Acciones',
      View: 'Ver',
      'Channels (Mandatory)': 'Canales (Obligatorio)',
      'Channel type (Mandatory)': 'Tipo de canal (Obligatorio)',
      'Please select a channel type first':
        'Por favor seleccione un tipo de canal primero',
      'No channels available for this type':
        'No hay canales disponibles para este tipo',
      'No sales products available': 'No hay productos de venta disponibles',
      Pending: 'Pendiente',
      Completed: 'Completado',
      'Loading more...': 'Cargando más...',
      'Standard templates': 'Plantillas estándar',
      'Pre-approved templates': 'Plantillas pre-aprobadas',
      Recipients: 'Destinatarios',
      'Filter recipients': 'Filtrar destinatarios',
      'Not sent': 'No enviados',
      Sent: 'Enviados',
      Responses: 'Respuestas',
      'Response rate': '% Resp.',
      'Only approved sequences can be used':
        'Solo secuencias con plantillas pre-aprobadas pueden ser usadas',
      'Send messages': 'Enviar mensajes',
      cant_deactivate_with_clients_assigned:
        'No es posible desactivar usuarios que tengan conversaciones asignadas. Por favor transferir todas sus conversaciones a otro usuario e intentar nuevamente.',
      'Transfer conversations': 'Transferir conversaciones',
      'This contact is already in Uniboxi': 'Este contacto ya está en Uniboxi',
      newWhatsappMessageClientCardDescription:
        'Se ha contactado a {{firstName}} en {{count}} tarjetas diferentes. Puedes hacer click en las tarjetas y continuar la conversación, o seguir adelante y escribirle desde el nuevo número de WhatsApp seleccionado.',
      newWhatsappMessageClientCardDescriptionSameChannel:
        'Se ha contactado a {{firstName}} en {{count}} tarjetas diferentes. Puedes hacer click en las tarjetas y continuar la conversación, la primera tarjeta corresponde al mismo canal.',
      client: 'cliente',
      'created by on': 'Creado por {{name}} el {{date}}',
      'Send batch messages': 'Enviar mensajes masivos',
      'Send batch message': 'Enviar mensaje masivo',
      'Batch messages': 'Mensajes masivos',
      'Send now': 'Enviar ahora',
      'Schedule send': 'Programar envío',
      'Send later': 'Enviar más tarde',
      'day/s': 'día/s',
      'Whatsapp Warning Batch Message Title':
        'Aviso importante antes de enviar mensajes masivos por WhatsApp',
      'Whatsapp Warning Batch Message Description 1':
        'Ten en cuenta lo siguiente antes de usar esta función:',
      'Whatsapp Warning Batch Message Description 2 - Title':
        '1. WhatsApp cobra una tarifa',
      'Whatsapp Warning Batch Message Description 2 - Body':
        ' por cada mensaje de marking enviado.',
      'Whatsapp Warning Batch Message Description 2 - Subtext':
        'Puedes ver los precios actuales ',
      'Whatsapp Warning Batch Message Description 2 - Link': 'aquí',
      'Whatsapp Warning Batch Message Description 3 - Title':
        '2. WhatsApp puede bloquear temporalmente tu número',
      'Whatsapp Warning Batch Message Description 3 - Body':
        ' si envias demasiados mensajes de marketing o si los destinatarios reportan tus mensajes como spam.',
      'Must select a template': 'Debes seleccionar una plantilla',
      'Schedule your message for a specific time':
        'Programa como deseas enviar tu mensaje',
      'Help text for multi-day sending':
        'Si la base de destinatarios es muy grande, puedes dividir el envío en varios días. Por ejemplo, si necesitas enviar un mensaje a 10.000 destinatarios y decides repartirlo en 5 días, se enviarán 2.000 mensajes por día durante 5 días consecutivos. También puedes elegir si el envío se realiza solo en días hábiles.',
      Understood: 'Entendido',
      'Clear date': 'Limpiar fecha',
      users: 'usuarios',
      selected: 'seleccionados',
      Sequence: 'Secuencia',
      Template: 'Plantilla',
      'Multi-day sending': 'Envío en múltiples días',
      Optional: 'Opcional',
      'Distribute sending over:': 'Repartir el envío en:',
      'Date is required when scheduling': 'La fecha es requerida al programar',
      'Select a template': 'Selecciona una plantilla',
      Channels: 'Canales',
      Tags: 'Etiquetas',
      'Excluded Tags': 'Etiquetas Excluidas',
      'Excluded Channels': 'Canales Excluidos',
      Include: 'Incluir',
      Exclude: 'Excluir',
      'Conversation owner': 'Propietario de la conversación',
      'Creation date': 'Fecha de creación',
      Until: 'Hasta',
      'Last message received date': 'Fecha de último mensaje recibido',
      'Last message sent date': 'Fecha de último mensaje enviado',
      'Filter recipients (subtitle)':
        'Filtra a continuación los destinatarios a los que deseas enviar el mensaje.',
      'Sequences (approved only)': 'Secuencias (plantillas preaprobadas)',
      'Only clients of the same channel type can be selected':
        'Solo se pueden seleccionar clientes del mismo tipo de canal',
      Clients: 'Clientes',
      Favorites: 'Favoritos',
      'Only favorites': 'Solo favoritos',
      'Conversation owners': 'Propietarios de la conversación',
      'Applied filters': 'Filtros aplicados',
      'No filters applied': 'No hay filtros aplicados',
      'recipients selected': 'usuarios seleccionados',
      From: 'Desde',
      Before: 'Antes',
      until: 'Hasta',
      'You must select a channel': 'Debes seleccionar un canal',
      'You must apply at least one filter': 'Debes aplicar al menos un filtro',
      'Search templates...': 'Buscar plantillas...',
      'Select the type of message you want to send':
        'Selecciona a continuación el tipo de mensaje que deseas enviar.',
      'Instant Batch Send Created Description':
        'Mensaje masivo enviado correctamente',
      'Scheduled Batch Send Created Description':
        'Mensaje masivo programado correctamente',
      'Batch send scheduled success message':
        '¡Listo! Tu mensaje está siendo programado.',
      'Batch send instant success message':
        '¡Listo! Tu mensaje saldrá en unos minutos',
      'Batch send manual success message': '¡Mensajes en proceso!',
      'Batch send manual success subtitle part 1':
        'Estamos enviando tus mensajes a todos los destinatarios. Esto puede tardar hasta ',
      'Batch send manual success subtitle part 2': '15 segundos',
      'Batch send manual success subtitle part 3':
        ' en reflejarse en las conversaciones. Puedes cerrar esta ventana mientras tanto.',
      'You can view your message statistics from':
        'Puedes ver las estadísticas de tu mensaje desde',
      'this page': 'esta página',
      'Select date': 'Selecciona fecha',
      'Select date and time': 'Selecciona fecha y hora',
      'Select a future date and time': 'Selecciona una fecha y hora futura',
      Included: 'Incluido',
      Excluded: 'Excluido',
      Only: 'Solo',
      Not: 'No',
      And: 'Y',
      Or: 'O',
      'No search results found': 'No hay resultados para esta búsqueda.',
      'View recipients list': 'Ver lista de destinatarios',
      'Selected recipients': 'Destinatarios seleccionados',
      'No recipients found': 'No se encontraron destinatarios',
      'Unknown client': 'Cliente desconocido',
      'Total recipients': 'Total de destinatarios',
      'Loading...': 'Cargando...',
      'users selected': 'usuarios seleccionados',
      'Include only business days': 'Incluir solo días hábiles',
      'Enter value': 'Ingrese valor',
      'No information fields available':
        'No hay campos de información disponibles',
      ImportPhase: '{{phase}} / 2',
      ...esIntegrations,
      ...esLogin,
      ...esTopbar,
      ...esDrawer,
      ...esAccount,
      ...esEllipsisPopover,
      ...esTemplates,
      ...esSequences,
      ...esRules,
      ...esChat,
      ...esFilter,
      ...esDashboard,
      ...esNotifications,
      ...esAutomation,
      ...esReports,
      ...esTimezones,
      ...esTools,
      ...esSales,
    },
  },
};
